const morningSVG = `
<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" version="1.1" viewBox="0 0 1200 1200">
 <path d="m600 324c-165.68 0-300 134.3-300 300h600c0-165.7-134.32-300-300-300z"/>
 <path d="m121.05 398.53c-4.0547-1.582-8.4336-2.5312-13.055-2.5312-19.895 0-36 16.129-36 36 0 15.254 9.5273 28.234 22.945 33.469l-0.023437 0.070312 168.01 65.566 26.172-67.078-168.01-65.566z"/>
 <path d="m416.77 129.25c-5.6406-12.508-18.156-21.254-32.773-21.254-19.895 0-36 16.129-36 36 0 5.2695 1.1992 10.234 3.2266 14.746l-0.058593 0.023437 75.602 168 65.664-29.543-75.602-168z"/>
 <path d="m1128 432c0-19.871-16.105-36-36-36-4.6211 0-9 0.94922-13.066 2.5312l-0.023438-0.070312-168.02 65.566 26.184 67.078 168.02-65.566-0.023438-0.070312c13.402-5.2344 22.93-18.215 22.93-33.469z"/>
 <path d="m816 108c-14.617 0-27.133 8.7461-32.762 21.254l-0.058593-0.023437-0.3125 0.71875c-0.011719 0.023437-0.023438 0.046875-0.035157 0.070312l-75.254 167.21 65.652 29.543 75.602-168-0.046875-0.023437c2.0156-4.5117 3.2148-9.4766 3.2148-14.746 0-19.871-16.105-36-36-36z"/>
 <path fill="#5ad324" d="m0 672h1200v72h-1200z"/>
 <path fill="#5ad324" d="m528 1092h144v-48h120l-192-300-192 300h120z"/>
</svg>
`;

const daySVG = `
<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" version="1.1" viewBox="0 0 1200 1200">
 <path d="m862.5 600c0 69.609-27.656 136.4-76.875 185.63-49.219 49.223-116.02 76.875-185.63 76.875-69.613 0-136.4-27.656-185.63-76.875-49.223-49.219-76.875-116.02-76.875-185.63s27.656-136.4 76.875-185.63c49.219-49.223 116.02-76.875 185.63-76.875 69.609 0.09375 136.31 27.75 185.53 76.969 49.219 49.219 76.875 115.92 76.969 185.53zm-262.5 337.5c-20.719 0-37.5 16.781-37.5 37.5v112.5c0 20.719 16.781 37.5 37.5 37.5s37.5-16.781 37.5-37.5v-112.5c0-9.9375-3.9375-19.5-10.969-26.531s-16.594-10.969-26.531-10.969zm0-675c9.9375 0 19.5-3.9375 26.531-10.969s10.969-16.594 10.969-26.531v-112.5c0-20.719-16.781-37.5-37.5-37.5s-37.5 16.781-37.5 37.5v112.5c0 9.9375 3.9375 19.5 10.969 26.531s16.594 10.969 26.531 10.969zm-337.5 337.5c0-9.9375-3.9375-19.5-10.969-26.531s-16.594-10.969-26.531-10.969h-112.5c-20.719 0-37.5 16.781-37.5 37.5s16.781 37.5 37.5 37.5h112.5c9.9375 0 19.5-3.9375 26.531-10.969s10.969-16.594 10.969-26.531zm825-37.5h-112.5c-20.719 0-37.5 16.781-37.5 37.5s16.781 37.5 37.5 37.5h112.5c20.719 0 37.5-16.781 37.5-37.5s-16.781-37.5-37.5-37.5zm-195.84 276.14c-6.9844-7.2188-16.594-11.344-26.625-11.438-10.078-0.09375-19.734 3.8906-26.859 10.969-7.0781 7.125-11.062 16.781-10.969 26.859 0.09375 10.031 4.2188 19.641 11.438 26.625l79.547 79.594c14.672 14.672 38.391 14.672 53.062 0s14.672-38.391 0-53.062zm-583.31-477.28c14.719 14.203 38.062 14.016 52.547-0.46875 14.484-14.484 14.672-37.828 0.46875-52.547l-79.547-79.594c-14.672-14.672-38.391-14.672-53.062 0-14.672 14.672-14.672 38.391 0 53.062zm0 477.28-79.594 79.547c-7.0312 7.0312-10.969 16.594-10.969 26.531s3.9375 19.5 10.969 26.531c14.672 14.672 38.391 14.672 53.062 0l79.547-79.547c7.2188-6.9844 11.344-16.594 11.438-26.625 0.09375-10.078-3.8906-19.734-10.969-26.859-7.125-7.125-16.781-11.062-26.859-10.969-10.031 0.09375-19.641 4.2188-26.625 11.438zm556.82-466.31c9.9375 0 19.453-3.9375 26.484-10.969l79.594-79.547c14.672-14.672 14.672-38.391 0-53.062-14.672-14.672-38.391-14.672-53.062 0l-79.547 79.594c-10.734 10.688-13.922 26.812-8.1094 40.828 5.8125 14.016 19.453 23.156 34.641 23.156z"/>
</svg>
`;

const eveningSVG = `
<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" version="1.1" viewBox="0 0 1200 1200">
 <path fill="#d3245a" d="m1200 744v-72h-1200v72h528v48h-120l192 300 192-300h-120v-48z"/>
 <path d="m600 324c-165.68 0-300 134.3-300 300h600c0-165.7-134.32-300-300-300z"/>
 <path d="m121.05 398.53c-4.0547-1.582-8.4336-2.5312-13.055-2.5312-19.895 0-36 16.129-36 36 0 15.254 9.5273 28.234 22.945 33.469l-0.023437 0.070312 168.01 65.566 26.172-67.078-168.01-65.566z"/>
 <path d="m416.77 129.25c-5.6406-12.508-18.156-21.254-32.773-21.254-19.895 0-36 16.129-36 36 0 5.2695 1.1992 10.234 3.2266 14.746l-0.058593 0.023437 75.602 168 65.664-29.543-75.602-168z"/>
 <path d="m1128 432c0-19.871-16.105-36-36-36-4.6211 0-9 0.94922-13.066 2.5312l-0.023438-0.070312-168.02 65.566 26.184 67.078 168.02-65.566-0.023438-0.070312c13.402-5.2344 22.93-18.215 22.93-33.469z"/>
 <path d="m816 108c-14.617 0-27.133 8.7461-32.762 21.254l-0.058593-0.023437-0.3125 0.71875c-0.011719 0.023437-0.023438 0.046875-0.035157 0.070312l-75.254 167.21 65.652 29.543 75.602-168-0.046875-0.023437c2.0156-4.5117 3.2148-9.4766 3.2148-14.746 0-19.871-16.105-36-36-36z"/>
</svg>
`;

const nightSVG = `
<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" version="1.1" viewBox="0 0 1200 1200">
 <path d="m978.8 915.3c-22.246 3.3125-44.93 4.9805-67.477 4.9805-251.04 0-455.3-204.27-455.3-455.32 0-127.08 51.098-245 143.83-332.02l34.105-32.027-46.297 6.8516c-113.73 16.895-218.11 74.23-293.95 161.46-76.598 88.078-118.79 200.95-118.79 317.81 0 267.18 217.38 484.56 484.59 484.56 123.66 0 241.36-46.559 331.45-131.12l34.129-32.027z"/>
</svg>
`;

function getTimeOfDayIcon(date) {
  const hours = new Date(date * 1000).getHours();

  if (hours >= 5 && hours < 12) {
    return morningSVG;
  } else if (hours >= 12 && hours < 17) {
    return daySVG;
  } else if (hours >= 17 && hours < 21) {
    return eveningSVG;
  } else {
    return nightSVG;
  }
}

function getTimeOfDayIconFromStr(timeOfDay) {
  if (timeOfDay === 'Morning') {
    return morningSVG;
  }
  if (timeOfDay === 'Day') {
    return daySVG;
  }
  if (timeOfDay === 'Evening') {
    return eveningSVG;
  }
  if (timeOfDay === 'Night') {
    return nightSVG;
  }
}

function getTimeOfDay(date) {
  const hours = new Date(date * 1000).getHours();

  if (hours >= 5 && hours < 12) {
    return 'Morning';
  } else if (hours >= 12 && hours < 17) {
    return 'Day';
  } else if (hours >= 17 && hours < 21) {
    return 'Evening';
  } else {
    return 'Night';
  }
}

function getTimeOfDayTimeStamp(timeOfDay, date) {
  if (timeOfDay === 'Morning') {
    return +new Date(date * 1000).setHours(6, 0, 0, 0) / 1000;
  }
  if (timeOfDay === 'Day') {
    return +new Date(date * 1000).setHours(12, 0, 0, 0) / 1000;
  }
  if (timeOfDay === 'Evening') {
    return +new Date(date * 1000).setHours(19, 0, 0, 0) / 1000;
  }
  if (timeOfDay === 'Night') {
    // if after 10pm set to 10pm
    // else set to 1am
    const hours = new Date(date * 1000).getHours();
    if (hours >= 22) {
      return +new Date(date * 1000).setHours(22, 0, 0, 0) / 1000;
    }
    return +new Date(date * 1000).setHours(1, 0, 0, 0) / 1000;
  }
}

export {
  getTimeOfDay,
  getTimeOfDayIcon,
  getTimeOfDayIconFromStr,
  getTimeOfDayTimeStamp
};
